import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./styles.module.scss";

// Named export
export const Chatbot = ({ className, chatbot }) => {
  return (
    <div className={cn(className, styles.chatbot)}>
      <div dangerouslySetInnerHTML={{ __html: chatbot }} />
    </div>
  );
};

// Default export
export default Chatbot;
